














import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {CashoutData, Sku, SuggestedCashoutValue} from "../models";
import {cashoutEventBus, CashoutEvents} from "../bus";
import {formatCurrency} from "../util/number";

@Component
export default class CashoutModalPleaseWait extends Vue {
    @Prop()
    cashoutData!: CashoutData;
    selectingSku: Sku | null = null;
    stockSuggestions: SuggestedCashoutValue[] = [];
    formatCurrency = formatCurrency;

    mounted(): void {
        cashoutEventBus.$on(CashoutEvents.UI_BLOCK, this.modalOpen);
        cashoutEventBus.$on(CashoutEvents.UI_UNBLOCK, this.modalClose);
    }

    modalOpen(sku: Sku) {
        this.$modal.show('please-wait-modal');
    }

    modalClose() {
        this.$modal.hide('please-wait-modal');
    }

    modalOpened() {
        // Use BS4 scroll locking, duplicated here as this is a custom modal
        // document.body.classList.add('bodal-open')
    }

    modalClosed() {
        // Use BS4 scroll locking, duplicated here as this is a custom modal
        // document.body.classList.remove('bodal-open')
    }
}
